import { useRef, useCallback } from 'react';

// Attaches to a sentinel element; fires onLoadMore when it scrolls into view.
// Usage: const ref = useInfiniteScroll(hasMore, loading, loadMore); <div ref={ref} />
export default function useInfiniteScroll(hasMore, loading, onLoadMore) {
  const observer = useRef(null);
  return useCallback((node) => {
    if (loading) return;
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && hasMore) onLoadMore();
    }, { rootMargin: '200px' });
    if (node) observer.current.observe(node);
  }, [hasMore, loading, onLoadMore]);
}
